document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.ips-slider').forEach(function (el) {
    if (el.swiper) return;

    const root = el.closest('.image-product-slider');
    const prev = root && root.querySelector('.ips-prev');
    const next = root && root.querySelector('.ips-next');

    const delay   = (Number(el.getAttribute('data-autoplay-speed')) || 5) * 1000;
    const gap     = Number(el.getAttribute('data-spacing')) || 8;
    const useBar  = el.getAttribute('data-pagination-progressbar') === 'true';

    // Duplica slide solo se sono poche (per un loop fluido)
    const wrap = el.querySelector('.swiper-wrapper');
    if (!wrap) return;
    const minSlides = 8;
    const base = Array.from(wrap.children);
    while (base.length && wrap.children.length < minSlides) {
      wrap.appendChild(base[wrap.children.length % base.length].cloneNode(true));
    }

    const opts = {
      loop: true,
      autoplay: { delay, disableOnInteraction: false, pauseOnMouseEnter: true },
      speed: 450,
      spaceBetween: gap,
      slidesPerGroup: 1,
      roundLengths: true,
      preventInteractionOnTransition: true,
      observeParents: true,
      observer: true,
      breakpoints: {
        0:    { slidesPerView: 2 },
        768:  { slidesPerView: 2 },
        992:  { slidesPerView: 2 },
        1200: { slidesPerView: 2, spaceBetween: gap }
      }
    };

    if (prev && next) opts.navigation = { prevEl: prev, nextEl: next };
    const pag = el.querySelector('.swiper-pagination');
    if (useBar && pag) opts.pagination = { el: pag, type: 'progressbar' };

    new Swiper(el, opts);
  });
});
